import { useAppSelector } from '../../../redux/store';
import useGetData from '../../../Services/useGetData';
import globals from '../../../Globals.json';
import * as S from './styles';
import PanelLoading from '../../Loading/PanelLoading';
import Format from '../../../Services/Format';
import { buildDashboardQuery } from '../dateFilters';

interface SalesByStore {
  store_id: number;
  sales: {
    payment_type_id: number;
    payment_type_description: string;
    total_sales: string;
    total_transactions: string;
  }[];
}

export function SalesByStore({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}) {
  const { stores, storeActive } = useAppSelector(
    ({ storeMeReducer }) => storeMeReducer.value
  );

  const { data, isLoading } = useGetData({
    path: globals?.api?.salesByStore,
    query: buildDashboardQuery({ storeId: storeActive?.id, startDate, endDate }),
  });

  return (
    <S.Container>
      <h3>Vendas por Loja</h3>
      <div className="wrapper">
        {isLoading ? (
          <PanelLoading />
        ) : data?.length > 0 ? (
          data.map((sales: SalesByStore) => {
            const storeName = stores?.relationships?.stores.find(
              (item: any) => item.id === sales.store_id
            )?.company_name;

            return (
              <div key={sales.store_id} className="card">
                <div className="description">
                  <h4 className="name">{storeName || 'Loja Desconhecida'}</h4>
                </div>

                {sales.sales.map((sale, index) => (
                  <div key={index} className="details">

                    <span className="total-transactions">
                      {`Transações: ${sale.total_transactions}`}
                    </span>
                    <span className="total-sales">
                      {Format.formatCurrencyBr(sale.total_sales)}
                    </span>
                  </div>
                ))}
              </div>
            );
          })
        ) : (
          <div className="not-data">Ainda não há vendas cadastradas!</div>
        )}
      </div>
    </S.Container>
  );
}
